import { Component, ComponentChild, h } from 'preact'
import InputGroup from '../../control-components/ui-components/InputGroup'
import InputGroupWithIcons from '../../control-components/ui-components/InputGroupWithIcons'
import Icon from '../assets/index'
import { arrayMove, SortableContainer, SortableElement, SortableHandle } from 'react-sortable-hoc'
import Union from '../../control-components/category/assets/Union'
import { t } from '../../libs/translationsUtils/translations'

interface Props {
  options: Array<string>,
  question: string,
  onChange: (data: {question?: string, options?: Array<string>}) => void,
  onDelete: () => void
}

interface State {
  newOption: string
}

const DragHandle = SortableHandle(() => (
  <span className='drag-handle'>
    <Union />
  </span>)
)

const SortableList = SortableContainer(({ children }: { children: ComponentChild }) => children)
const SortableItem = SortableElement(({ children }: { children: ComponentChild }) => children)

class Poll extends Component<Props, State> {
  constructor (props: Props) {
    super(props)
    this.state = {
      newOption: ''
    }

    this.addNewItemToList = this.addNewItemToList.bind(this)
    this.updateItemInList = this.updateItemInList.bind(this)
    this.deleteItemFromList = this.deleteItemFromList.bind(this)
    this.onItemsSorted = this.onItemsSorted.bind(this)
  }

  addNewItemToList () {
    this.props.onChange({ options: this.props.options.concat([this.state.newOption]) })
    this.setState({ newOption: '' })
  }

  deleteItemFromList (idx: number) {
    let newList = this.props.options
    newList.splice(idx, 1)
    this.props.onChange({ options: newList })
  }

  updateItemInList (newValue: string, idx: number) {
    this.props.options[idx] = newValue
    this.props.onChange({ options: this.props.options })
  }

  onItemsSorted ({ oldIndex, newIndex } : {oldIndex: number, newIndex: number}) {
    this.props.onChange({ options: arrayMove(this.props.options, oldIndex, newIndex) })
  }

  render ({ question, options, onChange, onDelete }: Props, { newOption }: State) {
    return (
      <div className='poll-wrapper'>
        <div className='poll-question'>
          <InputGroup
            title={t('Forum', 'topic.editor.poll.question.title')}
            placeholder={t('Control', 'poll.placeholder.question')}
            type='text'
            qaClasses='qa-poll-question'
            onChange={(e: ChangeEvent) => onChange({ question: e.target.value })}
            value={question} />
        </div>

        <div className='poll-options'>
          <strong>{t('Forum', 'topic.editor.poll.answers.title')}</strong>

          <SortableList
            useDragHandle
            onSortEnd={this.onItemsSorted}
          >
            <div>
              {
                options.map((item, idx) => (
                  <SortableItem index={idx} key={idx}>
                    <InputGroupWithIcons
                      attributes={{
                        type: 'text',
                        value: item
                      }}
                      className='qa-poll-option'
                      preIcon={<DragHandle />}
                      postIcon={<Icon onClick={() => this.deleteItemFromList(idx)} icon='close' />}
                      onChange={(newValue: string) => this.updateItemInList(newValue, idx)}
                    />
                  </SortableItem>
                ))
              }
            </div>
          </SortableList>

          <InputGroupWithIcons
            attributes={{
              type: 'text',
              value: newOption,
              placeholder: t('Forum', 'topic.editor.poll.answers.placeholder')
            }}
            className='qa-poll-add'
            preIcon={<Icon onClick={this.addNewItemToList} icon='add' />}
            onEnter={this.addNewItemToList}
            onChange={(newValue: string) => this.setState({ newOption: newValue })}
          />
        </div>

        <div className='poll-delete'>
          <span
            className='poll-delete-link'
            onClick={onDelete}
          >{t('Forum', 'Remove poll')}</span>
        </div>
      </div>
    )
  }
}

export default Poll
